import { FileAccountIcon } from './FileAccountIcon';

/**
 * author: Austin Andrews
 * id 94A8A0E0-B69E-4099-A32E-34B83449AFBC
 * name file-account
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-account.svg
 * tags
 * - Account / User 
 * - Files / Folders 
 */
export const ResumeIcon = FileAccountIcon;
export default ResumeIcon